export default __webpack_public_path__ + "./images/tn.4adb38ea.png";